type ApiSuffix<T extends string> = T extends `/${string}` ? never : T;

const normalize = (input: string): string => input.trim();

const universal = <T extends string>(suffix: ApiSuffix<T>) => `/api/${normalize(suffix)}`;

const getPathForVersion = (version: string, suffix: string) => `/api/${version}/${normalize(suffix)}`;

const v1 = <T extends string>(suffix: ApiSuffix<T>) => getPathForVersion('v1', suffix);

const v2 = <T extends string>(suffix: ApiSuffix<T>) => getPathForVersion('v2', suffix);

const v3 = <T extends string>(suffix: ApiSuffix<T>) => getPathForVersion('v3', suffix);

const v4 = <T extends string>(suffix: ApiSuffix<T>) => getPathForVersion('v4', suffix);

export const API_FACTORY = {
  universal,
  v1,
  v2,
  v3,
  v4,
};
